import useScreenWidth from "../../Hooks/useScreenWidth";
import { convertToBgImage } from "gbimage-bridge";
import { getImage } from "gatsby-plugin-image";

const usePopupImage = (images, bgImageName, artworkImageName) => {
  const screenWidth = useScreenWidth();
  let _bgImageName = "";
  if (screenWidth <= 768) {
    _bgImageName = `${bgImageName}_tablet`;
  } else {
    _bgImageName = `${bgImageName}_desktop`;
  }
  const _artworkImageNameMobile = `artwork_mobile_${artworkImageName}`;
  const _artworkImageNameDesktop = `artwork_desktop_${artworkImageName}`;
  const backgroundImage = convertToBgImage(getImage(images[_bgImageName]));

  const artworkImageMobile = images[_artworkImageNameMobile].gatsbyImageData;
  const artworkImageDesktop = images[_artworkImageNameDesktop].gatsbyImageData;
  return { backgroundImage, artworkImageMobile, artworkImageDesktop };
};

export default usePopupImage;
